// src/data/projectDetails.js

export const projectDetails = {
  1: {
    id: 1,
    title: 'Phonecert',
    subtitle: '가상악기 연주 서비스',
    team: '해핑',
    advisor: '강지헌 교수님',
    keywords: ['Real-time Ensemble', 'Hand Recognition', 'Virtual Instrument', 'Android APP'],
    images: ['/images/team1/001.jpg', '/images/team1/002.jpg', '/images/team1/003.jpg', '/images/team1/004.jpg', '/images/team1/005.jpg', '/images/team1/006.jpg'],
    description: `악기를 배우고 싶다는 마음은 누구에게나 있지만 실제로 이를 실행에 옮기기란 쉽지 않습니다. 특히 공간의 제약, 고가의 비용, 그리고 악기를 처음 접하는 초보자 입장에서의 부담감은 악기 연주의 진입 장벽으로 작용해왔습니다.

실제로 악기를 구매하거나 연습할 장소를 마련하는 일은 쉽지 않은 일이며 이러한 현실적인 문제로 인해 많은 이들이 악기 연주를 망설이게 됩니다.

이에 저희는 실제 악기가 없어도, 언제 어디서나 자유롭게 연주를 경험할 수 있는 환경을 제공하고자 본 서비스를 기획하였습니다.

폰서트는 스마트폰 하나만 있으면 피아노와 드럼을 연주하고 다른 사람과 합주할 수 있는 가상악기 서비스입니다. 카메라로 손의 움직임을 인식해서 실제 악기와 유사한 연주 경험을 제공합니다. 또한, 통신 지연없이 실시간으로 다른 사용자와의 합주가 가능합니다.

이 서비스를 통해 누구나 손쉽게 연주를 시작할 수 있고, 함께 연주하며 음악을 더욱 재미있게 즐길 수 있습니다. 연주를 조금 더 쉽게, 가까이에서 즐길 수 있도록 폰서트가 도움이 되었으면 합니다.`,
    technologies: {
      Skill: ['Kotlin', 'C++', 'Node.js', 'MongoDB'],
      Tool: ['Android Studio', 'Photon Realtime', 'ngrok', 'MediaPipe', 'FluidSynth', 'Midi'],
      Device: ['Android']
    },
    members: [
      {
        name: '권주연',
        role: '프론트엔드, 드럼 가상악기 구현, 피아노 검은 건반 개선',
        message: '벌써 1년이 지나있다는 게 안 믿겨… 뭘 했다는 게 안 믿겨 … 마무리까지 같이 잘 할 수 있었어서 너무 해핑이야~ 수고했어 회핑 아니 해핑이들 사랑행',
        song: 'saucy dog - shion'
      },
      {
        name: '김나연',
        role: '백엔드, 피아노 가상악기 구현, 합주 시스템',
        message: '수고했다',
        song: '스탠딩 에그 - 오래된 노래'
      },
      {
        name: '박효빈',
        role: '프론트엔드, 피아노 가상악기 구현, 므찐 발표',
        message: '얘들아 수고 많았어!',
        song: '허니크루 - 승리를 위해'
      },
      {
        name: '장지인',
        role: '백엔드, 드럼 가상악기 구현, 피아노 검은 건반 개선',
        message: '끝이라니!! 넘넘 고생 많았고 함께해서 행복했어~ 해핑 거인들아 사랑해',
        song: '별 - fly again'
      },
      {
        name: '김유나',
        role: '백엔드, 피아노 가상악기 구현, 합주 시스템',
        message: '처음 만났을 때 저희.. 친해질 수 있을까요..? 했는데 그게 벌써 1년 전이라니… 우리 졸프하느라 정말 고생 많았다~ 해핑자이언츠 사랑해',
        song: 'Harry Styles - Love Of My Life'
      }
    ],
    extra: {
      customSection: [
        {
          question: '하루 동안 휴대폰 없이 디지털 디톡스를 하게 된다면 누가 제일 먼저 금단 증상을 보일까요?',
          answer:
            '권주연: 무조건 권주연\n장지인: 무조건 권주연\n김나연: 저요\n김유나: 무조건 권주연. 인스타에서 모르는 릴스가 없음.\n박효빈: 일단 저는 아니에요'
        }
      ],
      thanksTo: `강지헌 교수님!!!

처음엔 일주일에 한번 회의하는게 부담으로 느껴지기도 했지만 .. 그래도 그렇게 회의한 덕분에 저희 팀도 매주 열심히 하나라도 완성해가려고 했던 것 같습니다. 교수님께서 매주 진심으로 피드백을 주셔서 저희가 개발 중에 오류가 생겨도 문제를 해결해 나가고 결국 완성시킬 수 있었습니다. 좋은 말씀 많이 해주셔서 감사합니다! 항상 감사드립니다!! 역시 럭키 찰스

사랑합니다 아빠 최고

- 해핑딸램이들 올림 (우리맘)`
    },
  },

  2: {
    id: 2,
    title: 'ElderEye',
    subtitle: '넘어짐 감지와 실시간 스트리밍이 가능한 홈 모니터링 앱',
    team: 'Cerberus',
    advisor: '이재호 교수님',
    keywords: ['IoT', 'Android', 'Deep Learning', 'MSA', 'WebRTC SFU'],
    images: ['/images/team2/001.png', '/images/team2/002.png', '/images/team2/003.png', '/images/team2/004.png', '/images/team2/005.png', '/images/team2/006.png'],
    description: `고령화 사회 속 안전 사각지대를 해소하기 위한 실시간 모니터링 솔루션인 [ ElderEye ]를 제작하였습니다. 한국은 세계에서 가장 빠르게 고령화가 진행되고 있으며, 독거노인의 고립 문제와 넘어짐 사고는 중요한 사회적 문제로 부상하고 있습니다.

ElderEye는 IoT, 딥러닝, 실시간 스트리밍 기술을 하나로 결합해, 상황을 빠르게 인지하고 대응할 수 있는 통합 시스템을 제공합니다. 딥러닝 기반의 쓰러짐 감지 모델, WebRTC SFU 기반의 실시간 스트리밍, gRPC 기반의 IoT 통신, 모바일 앱을 통한 사용자 인터페이스를 결합합니다. 이로 인해 노인의 실시간 상태를 가족과 보호자가 언제 어디서나 모니터링할 수 있도록 돕습니다.

실제 환경에 배치될 수 있는 시스템을 목표로, 저사양 장치(Raspberry Pi)에서도 동작 가능한 구조로 설계했습니다. MSA(Microservice Architecture)를 기반으로 서버 구조를 분산화 하여 확장성과 유지 보수성을 확보하였습니다. 또한, 데이터의 안전한 관리를 위해 암호화 저장 방식을 도입하고, 사용자 인증 및 권한 관리를 위한 JWT 기반의 인증 체계와 POLP를 적용하여, 서비스의 보안성과 신뢰성을 높였습니다.

ElderEye의 쓰러짐 감지 영역에서는 CNN + AE + GRU + Transformer로 구성된 하이브리드 아키텍처 모델을 개발하였습니다. 분류 성능, 추론 속도, 모델 경량화 세 가지 요소를 균형 있게 최적화하여 저사양 디바이스에서도 실시간으로 정확한 쓰러짐 감지를 할 수 있도록 구현했습니다.

이 프로젝트는 단순히 위험을 감지하는 데 그치지 않고, 가족과의 연결 그리고 데이터 기반의 실시간 대응, 사회적 안정망의 기술적 대체 가능성을 실험하는 과정이기도 합니다. ElderEye는 기술을 통해 사람을 더 가깝게 연결하고, 더 안전한 일상을 제공하고자 합니다.`,
    technologies: {
      Skill: ['Node.js', 'FastAPI', 'React Native', 'MySQL', 'Redis (Queue 및 Pub/Sub)', 'Pytorch'],
      Tool: ['WebRTC-SFU', 'WebSocket', 'gRPC', 'Docker', 'Promethesus', 'Grafana', 'Git', 'Figma'],
      Device: ['Raspberry Pi']
    },
    members: [
      {
        name: '김은영',
        role: 'AI Part: 쓰러짐 감지 딥러닝 모델 개발',
        message: '수고 많았어! ★ 앞으로 꽃길만 걷자 ★',
        song: '포스트말론 - Circles'
      },
      {
        name: '안희원',
        role: 'UI/UX 설계, 안드로이드 앱 개발, IoT 통신 (gRPC), DB 설계 및 연동, 백엔드 서버 구축, 딥러닝 추론 파이프라인 및 Grad-CAM 시각화 적용',
        message: '화학과에서 출발했지만, 기술과 문제 해결에 대한 관심으로 버틸 수 있었던 것 같습니다. 저승으로 가버린 우리 불쌍한 [카메라 1호]를 기억하겠습니다 :(',
        song: '범퍼카 - 기리보이'
      },
      {
        name: '유예린',
        role: 'UI/UX 설계, 안드로이드 앱 개발, IoT 인프라 구축, mediasoup producer & consumer 구현, 딥러닝 데이터 1차 수집',
        message: '1년 동안 프로젝트를 진행하면서 많은 걸 배웠습니다. 함께한 팀원들에게 정말 수고 많았다고 전하고 싶습니다.',
        song: 'Sandro Cavazza, Georgia Ku - Love To Lose'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀이 해리포터 세계관에 들어간다면, 각자 어떤 기숙사에 들어갈 것 같나요?',
          answer: '김은영 : 후플푸프 / 안희원 : 슬리데린 / 유예린 : 래번클로'
        }
      ]
    },
  },

  3: {
    id: 3,
    title: 'TemRun',
    subtitle: '음악과 함께, 템포에 맞춰 달리다',
    team: 'Temple',
    advisor: '이형규 교수님',
    keywords: ['Android APP', '러닝', '피드백', '음악추천', '게임'],
    images: ['/images/team3/001.png', '/images/team3/002.png', '/images/team3/003.png', '/images/team3/004.png', '/images/team3/005.png', '/images/team3/006.png'],
    description: `현대인의 건강 관심 증대로 러닝은 시간과 장소의 제약 없이 즐길 수 있는 대표적 운동으로 자리 잡았습니다. 그러나 기존 러닝 앱은 주로 거리·시간·속도 등 정량적 지표에만 의존하여 사용자 개개인의 실시간 생체 신호 변화나 운동 효율성을 충분히 반영하지 못하고 있습니다.

본 프로젝트는 모바일에 내장된 센서를 통해 호흡 패턴과 보행 리듬을 실시간으로 분석하고, AI 기반 맞춤형 피드백 및 음악 추천 기능을 통합한 모바일 애플리케이션을 개발하는 것을 목표로 합니다. 이를 통해 사용자에게 즉각적이고 개인화된 코칭을 제공하여 부상 위험을 줄이고 러닝 몰입도를 높이며 효율적인 운동 경험을 지원합니다.`,
    technologies: {
      Skill: ['Python', 'Kotlin', 'Java', 'JavaScript', 'SQL'],
      Framework: ['React', 'Spring Boot', 'TensorFlowLite', 'TensorFlow'],
      Tool: ['Android Studio', 'Intelli J', 'Figma', 'Github', 'Jupyter Notebook', 'MySQL'],
      Device: ['Android Phone (Accelerometer, Gyroscope)', '마이크 (이어폰 마이크)']
    },
    members: [
      {
        name: '권규나',
        role: '호흡 피드백 AI 모델1 설계 및 구현, 백엔드 개발',
        message: '다들 너무 고생했어~~ 학기 중에도 방학에도 1년 동안 열심히 했다~~^^',
        song: 'Oasis - Whatever'
      },
      {
        name: '이경미',
        role: '케이던스 예측 AI모델 설계 및 구현, 프론트 개발',
        message: '진짜 졸업이다!! 다들 1년 동안 너무 수고 많았어!!  푹 쉬자!!',
        song: "Kelly Clarkson - Stronger (What Doesn't Kill You)"
      },
      {
        name: '조윤경',
        role: '케이던스 예측 AI 모델 설계 및 구현, 프론트 개발',
        message: '우리 1년간 고생 많았다!! 졸업 미리 축하해♡',
        song: 'Taylor Swift - Anti-Hero'
      },
      {
        name: '김지현',
        role: '맞춤형 음악 추천 시스템 설계 및 구현, 프론트 개발',
        message: '드디어 졸업이다!!! 침대야 많이 기다렸지…내가왔어',
        song: 'lasah - MOTHER'
      },
      {
        name: '홍세희',
        role: '호흡 피드백 AI 모델2 설계 및 구현, 백엔드 개발',
        message: '“Because I Knew you, I have been changed For good.”',
        song: 'Kristin Chenoweth, Idina Menzel - For Good (From "Wicked")'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀이 해리포터 세계관에 들어간다면, 각자 어떤 기숙사에 들어갈 것 같나요?',
          answer:
            '홍세희: 래번클로\n권규나: 후플푸프\n조윤경: 후플푸프\n김지현: 후플푸프\n이경미: 후플푸프'
        }
      ],
      thanksTo: `- 지도교수님이신 이형규 교수님  
- 힘들때마다 격려해준 우리 팀원들, 반려묘 콩이&구름이, 반려 애플 민트 애민이, 자취방 제공해준 내 칭구, 춘이&첨지  
- 데이터 수집에 도움을 주신 권규나 어머님(어마무시한 심폐 지구력), 이경미의 가족들(아버지, 어머니, 이경미의 언니), 조윤경의 언니, 홍세희의 중고딩 친구들`
    },
  },

  4: {
    id: 4,
    title: '사랑공작소',
    subtitle: 'AI 기반 이상형 매칭 서비스',
    team: '큐피드',
    advisor: '유제혁 교수님',
    keywords: [
      'Android APP',
      'Dating APP',
      'Face Similarity AI',
      'Face Recognition',
      'Personalized Recommendation'
    ],
    images: ['/images/team4/1.png', '/images/team4/2.png', '/images/team4/3.png', '/images/team4/4.png', '/images/team4/5.png'],
    description: `현대 사회의 청년들은 고물가, 불안정한 고용, 주거 문제 등 다양한 사회·경제적 압박 속에서 심리적 부담을 안고 살아가고 있습니다. 이러한 현실은 연애와 인간관계의 시작마저 어렵게 만들고 있으며, 많은 이들이 마땅한 만남의 기회를 갖지 못하는 상황에 놓여 있습니다.

저희 팀은 이러한 문제의식에서 출발하여, AI 기반 이상형 매칭 서비스를 개발하게 되었습니다. 기존의 연애 매칭 서비스는 주관적인 설문이나 단순한 정보 기반 추천에 의존해, 사용자 개개인의 외적 취향과 같은 핵심 호감 요소를 충분히 반영하지 못하는 한계를 지니고 있었습니다. 이에 저희는 사용자의 프로필 사진과 이상형 선호 데이터를 AI가 학습하고, 개인의 외적 취향에 최적화된 상대를 추천하는 시스템을 기획했습니다.

또한, 사진 도용이나 허위 정보 등록을 방지하기 위해 다각도 얼굴 인증 기술을 적용함으로써, 보다 신뢰성 있는 만남 환경을 구축하고자 했습니다.

이번 프로젝트를 통해 기술이 단절된 사회적 연결을 회복하는 데 기여할 수 있다고 생각합니다. 이에, 저희는 만남을 보다 쉽고 효율적으로 만들어 줄 수 있는 AI 기반 연결 플랫폼을 제시하고자 합니다.`,
    technologies: {
      Languages: ['Python', 'Java'],
      'Frameworks & Libraries': ['Flask', 'Spring Boot', 'Retrofit', 'ResNet-101', 'InSightFace', 'Pytorch'],
      Tools: ['Android Studio', 'PyCharm', 'VSCode', 'IntelliJ', 'Figma', 'Docker', 'Postman'],
      DBMS: ['MySQL'],
      'Cloud & Devops': ['AWS'],
      Collaboration: ['Git', 'GitHub', 'Notion'],
      Device: ['Android Phone']
    },
    members: [
      {
        name: '정서희',
        role: '팀장, 백엔드',
        message: '실습실에서 개발하다가 즉흥으로 춘천 1박2일 여행간 거 잊지 못할 것 같아! 우리 넘 청춘같았어 ~. ~',
        song: 'INJI - ALL I WANNA DO'
      },
      {
        name: '전다혜',
        role: 'AI',
        message: '행복의 삶은 무지개 너머에 있지 않다. 이 순간 작은 행복들이 모여서 행복의 바다를 이룬다.',
        song: 'd4vd - Here With Me'
      },
      {
        name: '김영서',
        role: 'AI',
        message: '우리 팀원 최고! 여러분이라 여기까지 올 수 있었어요 ㅎㅎ',
        song: 'charli xcx - party 4 u'
      },
      {
        name: '권한나',
        role: 'AI',
        message: '큐피드들 함께라서 행복했어➵♡ 넓은 세계에서 다시 만나자!',
        song: 'Panic! At the Disco - High Hopes'
      },
      {
        name: '최정인',
        role: '프론트엔드',
        message: '새로운 일들로 가득한 1년 즐거웠습니다.',
        song: '아이유 - 이 지금'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀이 해리포터 세계관에 들어간다면, 각자 어떤 기숙사에 들어갈 것 같나요?',
          answer:
            '정서희 - 슬리데린\n전다혜 - 그리핀도르\n최정인 - 래번클로\n권한나 - 후플푸프\n김영서 - 래번클로'
        }
      ],
      thanksTo: `매 중간 발표 전, 교수님께서 주신 피드백 덕분에 팀원 모두 밤새워 수정하고 고민하며 프로젝트에 몰입할 수 있었습니다.
그 과정은 쉽지 않았지만, 결과적으로 저희가 더 나은 성과를 낼 수 있었고, 많이 배우는 계기가 되었습니다.
그리고 회의 중에 사주신 커피는 진심으로 너무 맛있었고, 덕분에 지친 팀원들의 텐션이 급상승할 수 있었습니다.
작은 격려와 조언 하나하나가 큰 힘이 되었습니다. 진심으로 감사드립니다!`
    },
  },

  5: {
    id: 5,
    title: 'INSIDE MIRROR',
    subtitle: '거울 앞, 당신의 하루가 스마트해진다',
    team: 'N°5 (넘파이브)',
    advisor: '강지헌 교수님',
    keywords: [
      'Smart Mirror',
      'Gaze Tracking',
      'Face Recognition',
      'User Interface',
      'Chatbot'
    ],
    images: ['/images/team5/1.png', '/images/team5/2.png', '/images/team5/3.png', '/images/team5/4.png', '/images/team5/5.png', '/images/team5/6.png'],
    description: `하루를 시작하며 마주하는 거울, 그 앞에 선 순간이 단지 자신의 모습을 비추는 것을 넘어 오늘의 준비를 돕는 출발점이 된다면 어떨까요? Inside Mirror는 일상 속에서 자연스럽게 사용자와 소통하는 스마트미러를 구현하고자 했습니다. 단순히 정보를 전달하는 기계가 아닌, 사용자의 시선과 목소리에 반응하고 얼굴을 인식하여 개인화된 서비스를 제공하는 홈 파트너 개발을 목표로 하였습니다.

Inside Mirror는 시선 추적, 음성 인식 기반 챗봇, 얼굴 인식 로그인 등 다양한 기술을 통합한 멀티모달 상호작용 기반 스마트미러 시스템입니다. 사용자는 거울 앞에 서기만 해도 자동으로 얼굴이 인식되며, 손을 사용하지 않고도 시선과 음성만으로 날씨 확인, 음악 재생, 일정 관리, 사진 촬영, PDF 미러링, 챗봇과의 대화 등 다양한 편의 기능을 사용할 수 있습니다. 또한 스마트미러와 온라인 페이지 간 연동 기능을 통해, 거울에서 확인한 정보나 기능들을 외부에서도 연속적으로 활용할 수 있도록 구성하였습니다.

기술 구현은 사용자 경험의 완성도를 높이는 방향으로 설계했습니다. 전체 시스템은 하드웨어와 소프트웨어가 유기적으로 연결되도록 구성되었으며, Windows 기반 웹 환경에서의 실시간 반응성과 안정성을 확보하는 데 중점을 두어 최적화를 진행하였습니다. 특히 챗봇은 대화형 LLM을 활용해 다양한 사용자 발화에 유연하게 대응할 수 있도록 했고, 자연스러운 흐름 구현에 중점을 두었습니다.

본 프로젝트는 스마트미러가 일상 속에서 지닌 실용적 가치에 중점을 두었습니다. 시선과 음성만으로 직관적인 조작이 가능하도록 설계하여, 사용자 편의성과 접근성을 극대화한 새로운 경험을 제시합니다.`,
    technologies: {
      Skill: ['Python', 'JAVA', 'JavaScript'],
      Tools: ['React', 'VScode', 'Spring Boot', 'IntelliJ', 'FastAPI', 'Pytorch', 'Figma'],
      Database: ['MySQL'],
      Cloud: ['AWS'],
      Device: ['Web Application', 'LattePanda Board'],
      Collaboration: ['Git', 'Notion']
    },
    members: [
      {
        name: '박유진',
        role: '팀장, 시선추적 기능 구현',
        message: '다들 너무 고생했어! 같이 보낸 시간이 오래 기억에 남을 거야. 앞으로 더 멋진 일들 많이 생기길!',
        song: '잔나비 - dolmaro'
      },
      {
        name: '김소정',
        role: '얼굴인식·시선추적 기능 구현',
        message: '팀원들 덕분에 1년 동안 즐거웠어 ♡ 가족만큼 자주 만난 우리 팀… 졸업하고 나서도 꾸준히 만날 수 있길! 이제 제발 연구실 탈출하자 =(^.^)=',
        song: '투투 - 일과 이분의 일'
      },
      {
        name: '장수현',
        role: '백엔드 개발, 얼굴인식 기능 구현',
        message: '우리 팀원들 너무 수고 많았고 덕분에 프로젝트 잘 마무리할 수 있었던 것 같아! 함께해서 정말 든든하고 즐거웠어:) 함께했던 모든 순간들이 정말 소중한 추억으로 남을 것 같아! 앞으로도 좋은 일들로 가득하길 진심으로 응원할게♡',
        song: '아이유 - 비밀의 화원'
      },
      {
        name: '조영채',
        role: '챗봇 비서 기능 구현',
        message: '연구실에서 며칠동안 노숙해도 행복했던 이유는 바로 너네 덕분이야~~ 이제 끝이 아닌 시작이라고 생각해!!(positive) 앞으로 우리 다 행복하고 잘 될 수 있도록 응원할게♡ 올해는 우리꺼!!!',
        song: 'Kanye West - I Wonder'
      },
      {
        name: '최윤영',
        role: '웹·모바일 반응형 UI 구현 및 API 연동',
        message: '오라! 달콤?한 졸업이여',
        song: 'THE ANXIETY, WILLOW & Tyler Cole - Meet Me At Our Spot'
      }
    ],
    extra: {
      customSection: [
        {
          question: '같은 고등학교였다면, 반장이 될 확률 1위와, 수업 시간마다 졸던 사람은? 급식에 진심일 것 같은 사람은?',
          answer: `반장이 될 확률 1위 - 박유진 : 남이 하는 꼴을 못 봄\n수업 시간마다 졸던 사람 - 최윤영, 조영채\n급식에 진심일 것 같은 사람 - 조영채, 박유진\n매점에 진심일 것 같은 사람 - 최윤영\n국어쌤 노트북 같이 가지러 갈 것 같은 사람 - 장수현\n키다리 책상으로 가서 친구랑 딴짓할 것 같은 사람 - 김소정`
        }
      ],
      thanksTo: `시선 추적 데이터 수집에 기꺼이 참여해 주신 곽승주, 고윤수, 김나연, 김도연, 김도은, 변다희, 백수민, 배서연, 박지인, 손지원, 이은정, 이지원, 이현주, 최영현 님께 진심으로 감사드립니다. 특히, 본 프로젝트의 방향 설정부터 데이터 수집 및 분석, 결과 도출에 이르기까지 전 과정에 걸쳐 아낌없는 지도와 조언을 아끼지 않으신 강지헌 교수님께 깊이 감사드립니다. 교수님의 끊임없는 격려와 세심한 피드백 덕분에 프로젝트를 끝까지 완수할 수 있었습니다.`
    },
  },

  6: {
    id: 6,
    title: 'MiniArca',
    subtitle: 'AI 기반 감정 분석 및 개인화 3D 시각 콘텐츠 생성 시스템',
    team: 'PATH',
    advisor: '강지헌 교수님',
    keywords: [
      'AI Applications',
      '3D Avatar Generation',
      'Emotion Analysis',
      'Image & Text Processing',
      'Video Diary Creation'
    ],
    images: ['/images/team6/1.png', '/images/team6/2.png', '/images/team6/3.png', '/images/team6/4.png', '/images/team6/5.png', '/images/team6/6.png'],
    description: `최근 MZ세대에게 인스타그램, 인생네컷, 제페토 등 다양한 방식으로 일상을 기록하고 감정을 표현하는 문화가 확산되고 있습니다. 이러한 트렌드는 개인의 정체성을 드러내고, 감정을 나누는 하나의 사회적 언어로 자리 잡고 있습니다.

MiniArca는 이 흐름 속에서 사용자가 자신의 하루를 보다 감성적으로 기록하고 공유할 수 있도록 고안된, 새로운 AI 기반 디지털 플랫폼입니다.

사용자가 자신의 모습을 촬영하고 일기를 작성하면, AI와 3D 모델링 기술을 통해 사용자의 모습과 일기 속 감정을 분석하여 아바타와 영상 일기를 자동으로 생성합니다. 나아가 감정 분석 결과를 바탕으로 감정 분석 리포트와 실물 피규어까지 제작하여, 디지털과 아날로그 감성을 아우르는 경험을 제공합니다.

MiniArca를 통한 일상 기록은 단순히 기록을 넘어 감정과 경험을 시각적으로 표현하는 새로운 문화로 확장될 수 있으며, 몰입감 있는 일상 기록의 새로운 방식을 제안합니다.`,
    technologies: {
      Skill: ['Python', 'JavaScript', 'HTML/CSS', 'C#'],
      Tool: [
        'VS Code',
        'Anaconda',
        'Unity',
        'Blender',
        'React',
        'Node.js+Express',
        'FastAPI',
        'MongoDB',
        'Stable Diffusion',
        'Gemini API',
        'Yolov5',
        'Git/GitHub'
      ],
      Device: ['webcam', '3D printer']
    },
    members: [
      {
        name: '노윤지',
        role: '백엔드, AI 서버 구축, AI 모델링',
        message: '처음 이 프로젝트를 기획하고 구상했을 때 가장 먼저 떠오른 생각은 할 수 있을까라는 생각이었습니다.  이게 진짜 연결이 될까라는 의문 속에서 시작한 프로젝트가 하나하나씩 완성을 해나가다 보니 어느새 졸업 전시를 앞두게 되었습니다. 밤새 오류를 고치고 수정했던 과정이 힘들었지만 앞으로의 활동의 밑거름이 되었으면 좋겠습니다. 처음이라 서툴기도 했지만 그래서 더 기억에 남는 프로젝트이고 즐거웠던 기억인 것 같습니다. 지금까지 고생한 팀원들에게 고맙고 수고 많았습니다. 마지막까지 최선을 다해 열심히 해봅시다!!  그리고 많은 조언을 해조신 강지헌 교수님께도 감사드립니다.',
        song: '아이유 - never ending story'
      },
      {
        name: '김보민',
        role: '백엔드, 3D 모델링, 프롬프트 엔지니어링',
        message: '도넛 가게에서 이야기하며 생각했던 아이디어가 이렇게 실제로 구현될 줄은 몰랐는데, 하나씩 구색이 갖춰지고 점점 완성되어가는 걸 보면서 뿌듯하고 신기했습니다. 걱정도 많았지만 팀원들과 함께였기에 끝까지 해낼 수 있었던 것 같습니다. 막막한 부분이 생길 때마다 같이 머리를 맞대고 결국은 해결해 나가던 순간들은 절대 잊지 못할 것 입니다. 밤을 새며 힘들었던 날들도 있었지만, 솔직히 많이 즐거웠습니다. path팀 정말 수고 많았고 고맙다는 말 전하고 싶습니다! 그리고 따뜻하게 지도해주신 강지헌 교수님께도 감사드립니다!',
        song: '임지숙 - grow up'
      },
      {
        name: '박현지',
        role: '백엔드, 프론트엔드, 3D 시각화',
        message: '기획부터 구현까지의 과정을 지나오면서 번뜩이는 아이디어에 짜릿했던 적도 있고 해결되지 않는 문제로 밤새 고민했던 적도 있었습니다. 분명한건 그 과정에서 저와 우리 팀원들 모두 성장했다는 점인 것 같습니다. 훗날 이 프로젝트를 떠올렸을때 제 인생에서 가장 강한 인상을 남긴 프로젝트로 기억되지 않을까 싶습니다. 모든 것이 처음이었기 때문이겠죠? 우리 팀원들 수고 많았고 함께 할 수 있어서 다행이었고 고맙습니다! 아직 끝나지 않았지만...  끝까지 최선을 다해봅시다!',
        song: 'boynextdoor - i feel good'
      },
      {
        name: '홍예빈',
        role: '프론트엔드, DB 관리, AI 모델링',
        message: `처음 이 아이디어를 구상하고 프로젝트 주제로 삼았을 때, 솔직히 우리가 정말 해낼 수 있을까… 하는 두려움이 컸습니다. 감정 분석, 3D 아바타 모델링, 영상 일기 제작까지 모든 것이 낯설고, 구현하기에는 너무 벅찬 일처럼 느껴졌습니다. 하지만 1년 동안 팀원 모두가 함께 고민하고, 때로는 부딪히며 끝까지 달려왔습니다. 처음 접하는 기술들을 하나하나 익혀가며 수많은 오류를 해결했고, 그 모든 과정은 제게 정말 값지고 의미 있는 경험이었습니다.

이번 프로젝트는 감정과 일상을 ‘기록하는 방식’을 새롭게 표현해보려는 시도였습니다. 익숙한 기록을 우리 팀만의 시선으로 다르게 풀어낼 수 있어, 더욱 뜻깊게 느껴졌습니다. 긴 시간 함께한 우리 PATH 팀, 윤지 언니, 현지 언니, 보민이 모두 정말 고생 많았어요! ‘PATH’라는 이름처럼, 각자의 길을 잘 찾아가며 이 프로젝트를 끝까지 완주한 게 참 뿌듯해요. 그리고 늘 아낌없는 조언을 보내주신 강지헌 교수님께도 진심으로 감사드립니다.`,
        song: 'CHEEZE(치즈) - 오늘의 기분'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀이 해리포터 세계관에 들어간다면, 각자 어떤 기숙사에 들어갈 것 같나요?',
          answer:
            '보민: 후플푸프\n윤지: 래번클로\n현지: 래번클로\n예빈: 그리핀도르'
        }
      ],
      thanksTo: `강지헌 교수님 저희 팀을 위해 매주 시간을 내주시고, 직접 꼼꼼하게 피드백과 질문, 조언을 해주신 덕분에 방향을 잘 잡을 수 있었습니다. 덕분에 많이 배우고 프로젝트를 더 깊이 있게 완성할 수 있었습니다. 진심으로 감사드립니다!`
    },
  },

  7: {
    id: 7,
    title: '하루벗',
    subtitle: '음성 기반 챗봇 서비스',
    team: '왕감자조림',
    advisor: '이형규 교수님',
    keywords: ['Android App', 'Chatbot', '감정 분석'],
    images: ['/images/team7/1.PNG', '/images/team7/2.PNG', '/images/team7/3.PNG', '/images/team7/4.PNG', '/images/team7/5.PNG', '/images/team7/6.PNG'],
    description: `현대 사회는 빠른 고령화 속도와 1인 가구 증가라는 이중적인 구조적 변화 속에 놓여 있습니다. 특히 중장년층 및 노년층의 경우, 가족 내 소통 단절이나 지역사회와의 단절로 인해 정서적 고립과 우울감을 겪는 비율이 점차 증가하고 있습니다. 이러한 사회적 배경 속에서 본 프로젝트는 정서적 지지와 일상적 교류를 제공할 수 있는 AI 기반 챗봇 시스템을 기획하게 되었습니다.`,
    technologies: {
      Skill: ['Python', 'JavaScript'],
      Tool: ['PyCharm', 'Unity', 'Android Studio', 'ReactNative', 'KoGPT', 'KoBERT'],
      Device: ['컴퓨터 및 태블릿']
    },
    members: [
      {
        name: '강태경',
        role: '프론트엔드 제작 및 연결',
        message: '편입 후 두 번째 학기에 졸업프로젝트를 진행하면서 어려움도 많았지만 팀원과 교수님의 도움으로 열심히 할 수 있었던 것 같습니다.',
        song: '데이식스 - 아직 거기 살아'
      },
      {
        name: '정보결',
        role: '백엔드 제작 및 연결',
        message: '편입하고 얼마 안 되어서 졸업프로젝트를 하게 되어 어려움을 많이 겪었지만 팀원과 함께하여 열심히 할 수 있었습니다.',
        song: '鄭智化 - 星星點燈'
      }
    ],
    extra: {
      customSection: [
        {
          question: '하루 동안 휴대폰 없이 디지털 디톡스를 하게 된다면 누가 제일 먼저 금단 증상을 보일까요?',
          answer: '강태경 팀원이 가장 먼저 금단 증상을 보일 것 같습니다. 해당 팀원은 평소 릴친자, 숏친자로 하루를 인스타와 유튜브로 보내는 팀원이므로 그렇게 생각하였습니다.'
        }
      ]
    },
  },

  8: {
    id: 8,
    title: 'Neuro Pilot',
    subtitle: '손은 필요 없어, 당근을 되찾고 싶은 마음만으로!',
    team: '로켓단',
    advisor: '이재호 교수님',
    keywords: ['EEG', 'React', 'Brain-Computer Interface'],
    images: ['/images/team8/1.png', '/images/team8/2.png', '/images/team8/3.png', '/images/team8/4.png', '/images/team8/5.png'],
    description: `멀고 먼 우주 어딘가, 평화로운 달나라에서 당근을 수확하며 살아가는 행복한 토끼들이 있습니다. 그러나 어느 날, 정체불명의 라쿤 군단이 하늘에서 나타나 토끼들의 소중한 당근을 모조리 훔쳐 달아나 버렸습니다. 토끼들은 직접 로켓을 타고 라쿤들에게서 당근을 되찾기로 결심합니다.

이 게임은 용감한 토끼들의 이야기를 배경으로 사용자의 뇌파를 기반으로 토끼를 조작하여 라쿤을 무찌르는 여정을 담고 있습니다. 단순히 키보드를 누르거나 마우스를 클릭하는 방식이 아닌 생각만으로 움직이는 전혀 새로운 방식의 게임을 구현하고자 하였습니다. 사용자는 Muse2 EEG 장치를 착용하고 ‘왼쪽’ 혹은 ‘오른쪽’을 상상하기만 하면 게임 속 토끼가 상상한 방향으로 움직이며 라쿤을 겨냥하게 됩니다.

게임 내에서는 화면 위에 라쿤이 좌측 혹은 우측 중 하나에 위치하고 있으며 사용자는 상상하는 방향에 따라 토끼가 탑승한 로켓에서 미사일을 발사해 라쿤을 공격할 수 있습니다. 게임이 진행되면서 라쿤의 위치는 랜덤하게 바뀌며 토끼는 사용자의 뇌파에 기반한 판단과 상상력에 따라 움직입니다. 이를 통해 사용자는 물리적 컨트롤러 없이 자신의 의식적 상상만으로 캐릭터와 상호작용하는 색다른 몰입감을 경험하게 됩니다.

BCI(Brain-Computer Interface) 기술은 초기에는 전신 마비나 루게릭병 환자의 의사소통을 돕기 위한 의료적 목적에서 시작되었으며 현재는 로봇 제어, 정서 인식, 게임, 예술 등 다양한 분야로 확장되고 있습니다. 생각만으로 기기를 조작할 수 있다는 점에서 기존 인터페이스의 한계를 넘는 혁신 기술로 주목받고 있으며 특히 신체적 제약 없이도 누구나 디지털 환경에 접근할 수 있다는 점에서 미래에는 메타버스, 스마트 헬스케어, 맞춤형 인터랙션 분야에 폭넓게 활용될 수 있습니다. 본 프로젝트는 이러한 기술의 가능성을 게임이라는 친숙한 형식을 통해 체험할 수 있도록 설계되었으며 BCI의 직관성과 몰입도를 누구나 쉽게 경험할 수 있는 대중적 인터페이스 사례로 구현하였습니다.`,
    technologies: {
      Skill: ['Python', 'JavaScript'],
      Tool: ['TensorFlow', 'PyTorch', 'React', 'Flask'],
      Device: ['Muse2']
    },
    members: [
      {
        name: '이현주',
        role: '팀장, 모델, 게임 UI 및 개발',
        message: '함께한 시간들이 정말 따뜻했고 소중했습니다! 우리 팀 모두 고생 많았고 감사했습니다!!!',
        song: '풍신 - Vaundy'
      },
      {
        name: '김도연',
        role: '모델, 게임 UI 및 개발',
        message: '다들 감사했습니다!',
        song: 'The open boat - 안다, 프라이머리'
      },
      {
        name: '고희주',
        role: '모델, 게임 UI 및 개발',
        message: '잘 졸업하고 갑니다',
        song: 'creespy - daydreaming'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀이 해리포터 세계관에 들어간다면, 각자 어떤 기숙사에 들어갈 것 같나요?',
          answer:
            '이현주 - 후플푸프\n고희주 - 래번클로\n김도연 - 그리핀도르'
        }
      ],
      thanksTo: `뇌파 측정 해주신 모든 분들 진심으로 감사합니다!!
강수진, 김제이, 김채연, 노진경, 노현이, 류도라, 박유진, 서해인, 원진솔, 윤다빈, 이가은, 이기진, 이혜준, 장소영, 정다은, 정아현, 조영채, 조유진, 하유정, 강지헌 교수님, 박민준 교수님, 박현준 교수님, 왕수현 교수님, 채현정 교수님, 최주희 교수님`
    },
  },

  9: {
    id: 9,
    title: '핏하게 입자 “FitZA”',
    subtitle: 'AI 기반 개인 옷장 분석 및 코디 추천 시스템',
    team: '아이파이브 (I-Five)',
    advisor: '유제혁 교수님',
    keywords: ['AI', 'FashionTech', 'Computer Vision', 'Personalization'],
    images: ['/images/team9/1.png', '/images/team9/2.png', '/images/team9/3.png', '/images/team9/4.png', '/images/team9/5.png', '/images/team9/6.png', '/images/team9/7.png', '/images/team9/8.png'],
    description: `현대 사회에서 옷은 개인의 정체성과 개성을 표현하는 중요한 수단이 되었습니다. 이에 따라 사람들은 자신의 스타일을 관리하고 표현하는 데 더 많은 관심을 기울이고 있습니다.

그러나 현재의 코디 추천 서비스는 온라인 쇼핑몰 상품 이미지나 상업적 데이터에 기반하기 때문에, 사용자가 실제로 가진 옷을 고려하지 못하거나 단순한 필터링 수준에 그치는 한계가 있습니다.

“FitZA” 프로젝트는 이러한 문제를 해결하고자, 사용자가 보유한 실제 옷의 이미지와 속성, 색상, 스타일을 AI로 분석하고, 날씨를 기반으로한 체감온도와 색상 조화를 반영하여 개인 맞춤형 코디를 추천하는 시스템을 개발하였습니다. AI가 각 옷의 특징과 색상 조화를 분석하여 누구나 자신의 옷장만으로도 쉽고 현실적인 스타일링을 완성할 수 있도록 지원합니다.

“FitZA”를 통해 사용자는 자신만의 옷을 보다 효율적이고 다양하게 활용할 수 있으며, 상업적 추천을 넘어 진짜 나에게 맞는 스타일을 찾는 즐거움을 경험할 수 있습니다.`,
    technologies: {
      Skill: ['python', 'java', 'SQL'],
      Tool: ['VScode', 'FastAPI', 'Pytorch', 'IntelliJ', 'React', 'Figma', 'Github', 'Docker'],
      Database: ['MySQL'],
      Cloud: ['AWS'],
      Device: ['Web Application']
    },
    members: [
      {
        name: '백수민',
        role: '프론트엔드, 모델 개발',
        message: 'FitZA 만들며 함께한 순간들 소중한 추억으로 남을 거야! 1년동안 다들 수고 많았고 고마웠어 (*,,•ᴗ•,,)ꔛꕤ 320-1 탈출이다!! =3=3',
        song: 'Charlie Puth – Attention'
      },
      {
        name: '김도원',
        role: '백엔드, 모델 개발',
        message: '프로젝트를 진행하는 동안 많은 고민과 시행착오도 있었지만, 그만큼 배우고 성장할 수 있었던 값진 시간이었습니다. 서로를 믿고 끝까지 함께해준 팀원들, 그리고 아낌없는 지도와 조언을 보내주신 교수님들께 진심으로 감사드립니다.',
        song: 'Ariana Grande - Yes, And?'
      },
      {
        name: '박소은',
        role: '백엔드, 모델 개발',
        message: '옷장에 오늘의 코디를 기록하듯, 많은 도움 주신 유제혁교수님과 소프트웨어교수님 그리고 든든한 팀원들 이름과 함께 우리의 FitZA도 값진 추억으로 차곡차곡 기록하겠습니다:) 그동안 다들 고생 정말 많았고! 앞으로도 더 파이팅해보자!',
        song: '윤하 - 사건의 지평선'
      },
      {
        name: '양서윤',
        role: '프론트엔드, 모델 개발',
        message: '다들 1년동안 수고했어! 졸업 미리 축하해~',
        song: 'aespa - Dirty Work'
      },
      {
        name: '이민혜',
        role: '프론트엔드, 모델 개발',
        message:
          '이번 “FitZA” 프로젝트를 진행하는 동안 아낌없는 지도와 격려를 보내주신 지도교수님께 진심으로 감사드립니다. 또한 개발 과정에서 다양한 의견과 도움을 주신 다른 교수님들, 응원해준 친구들과 가족들 등 모든 분들께 깊이 감사드립니다! 무엇보다 바쁜 일정 속에서도 함께 고민하고 끝까지 협력해 준 팀원들에게 감사의 마음을 전합니다.',
        song: '원필 - 행운을 빌어 줘'
      }
    ],
    extra: {
      customSection: [
        {
          question: '우리 팀을 하나의 밴드로 만든다면, 각자 어떤 포지션?',
          answer:
            '보컬 김도원\n드럼 이민혜\n건반 양서윤\n일렉 기타 박소은\n베이스 백수민'
        }
      ],
      thanksTo: `“FitZA” 프로젝트를 진행하는 동안 언제나 따뜻한 격려와 날카로운 조언으로 이끌어 주신 유제혁 교수님께 진심으로 감사드립니다. 연구의 방향을 잡고 아이디어를 구체화하는 과정부터 PPT 제작까지, 교수님께서 보내주신 관심과 세심한 피드백은 저희에게 큰 힘이 되었습니다. 부족한 점이 많은 저희 팀을 끝까지 믿어주시고, 현실적인 조언과 함께 연구자로서의 자세를 배울 수 있도록 지도해 주신 덕분에 이번 프로젝트를 더욱 의미 있게 완성할 수 있었습니다. 교수님 덕분에 새로운 시도도 주저하지 않고 이어갈 수 있었습니다. I-Five 드림`
    },
  },
};
